import React, { useState } from 'react'
import UploadSelect from '../UploadSelect'
import { displayImage } from '../../utils/config';
import { IoClose } from 'react-icons/io5';
import noImage from '../../assets/no-image.png'
import Input from '../../ui/forms/Input';
import Button from '../../ui/comp/Button';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Axios } from '../../utils/Axios';

function AddCategory({ onClose }) {

    const [exploreOpen, setExploreOpen] = useState(false)
    const [images, setimages] = useState([])
    const [name, setName] = useState("")

    const queryClient = useQueryClient()

    const { mutate, isPending, error, isError, isSuccess } = useMutation({
        mutationFn: async (formData) => {
            const res = await Axios.post('/category/add', formData);
            return res.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['category', 'products'])
        }
    })

    const addCategory = (e) => {
        e.preventDefault()
        const formData = new FormData()
        formData.append("image", images[0])
        formData.append("name", name)
        mutate(formData)
    }

    if (isSuccess) {
        onClose()
    }


    return (
        <div className='fixed w-full h-full top-0 left-0 z-[99999] flex justify-center items-center p-5'>

            {exploreOpen && <UploadSelect onClose={() => { setExploreOpen(false) }} sendFiles={(images) => { setimages(images) }} />}

            <div onClick={() => onClose()} className='absolute top-0 left-0 w-full h-full bg-black/40' />

            {/* Contents */}
            <div className="max-w-3xl w-full relative z-50 bg-white rounded-xl p-4">

                {/* Head */}
                <div className="pb-2 flex items-center w-full justify-between border-b">
                    <p className="">Add Category</p>
                    <button onClick={() => onClose()}><IoClose /></button>
                </div>

                {/* image */}
                <div className="justify-center flex items-center mt-5 cursor-pointer"
                    onClick={() => setExploreOpen(true)}>
                    <img
                        src={images?.length ? displayImage(images[0]) : noImage}
                        alt=""
                        className='size-28 rounded-full object-cover border'
                    />
                </div>

                <div className="mt-5 mx-auto max-w-xl pb-7 space-y-3">
                    <Input placeholder="Category Name" value={name} onChange={(e) => setName(e.target.value)} />
                    <Button onClick={addCategory} loading={isPending} fullWidth={true}>Add Category</Button>
                    {isError && (
                        <div className="text-red-500 text-sm capitalize text-center">{error?.response?.data || "Unknown"}</div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default AddCategory